import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {UserService} from "../../../../@shared/services/user.service";
import {environment} from "../../../../../environments/environment";
import {Clipboard} from "@angular/cdk/clipboard";
import {MatDialog} from "@angular/material/dialog";
import {CheckUserSteamComponent} from "../market/check-user-steam/check-user-steam.component";
import {UserTransactionComponent} from "./modals/user-transaction/user-transaction.component";
import {FastOfferOrderStatusEnum} from "../../../+payouts-by-skins/enums/fast-offer-order-status.enum";
import {PAYMENT_TRANSACTION_STATUS_LABELS} from "../../../../@core/enums/payment-transaction-status.enum";

export interface IGoFastRefill {
  amount: number;
  buyer: number;
  seller?: number | null;
  fast_deliver?: boolean | null;
  tid: number | string;
  email: string | null;
  method: string;
  msg: string;
  status: number;
  system: string;
  timestamp: string;
  // skin refill (method='market') extra fields
  name?: string;
  img?: string;
  state?: number | null;
  error?: string | null;
  reason?: string | null;
  statusText?: string;
  isOurBot?: boolean
}

export interface IHltvRefill {
  "orderId": number,
  "amount": number,
  "price": string,
  "timestampAdded": string,
  "timestampPaid": string,
  "ip": string,
  "paymentProvider": string,
  isPaid: boolean;
  "transaction": {
    "timestampAdded": string,
    "status": number,
    "email": string,
    "system": string,
    "recievedAmount": number,
    "method": string
    "userData": null | {
      paymentCard: string;
    }
  }
  isOurBot?: boolean
}


@Component({
  selector: 'app-refill',
  templateUrl: './refill.component.html',
  styleUrls: ['./refill.component.scss']
})
export class RefillComponent implements OnInit, AfterViewInit {
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';
  public fastOfferOrderStatusEnum = FastOfferOrderStatusEnum;
  public paymentStatusLabels = PAYMENT_TRANSACTION_STATUS_LABELS;

  public refillColumns: string[];
  public userRefills: MatTableDataSource<IGoFastRefill | IHltvRefill> = new MatTableDataSource<IGoFastRefill | IHltvRefill>();
  public isLoading: boolean = true;

  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort!: MatSort;

  constructor(private userService: UserService,
              public clipboard: Clipboard,
              public dialog: MatDialog) {
    this.refillColumns = this.isGoFast
      ? ['tid', 'status', 'buyer-email', 'amount', 'method', 'name', 'timestamp', 'msg']
      : ['orderId', 'amount', 'system', 'timestampAdded', 'ip', 'recievedAmount', 'status', 'data'];
  }

  ngOnInit() {
    this.userService.getUserRefills()
      .subscribe((data: (IGoFastRefill[] | IHltvRefill[])) => {
        this.isLoading = false;
        const sortField = this.isGoFast ? 'timestamp' : 'timestampAdded';
        const enriched = (data as any[]).map(item => ({
          ...item,
          statusText: this.getRefillStatusText(item),
        }));
        this.userRefills.data = enriched.sort(
          (a, b) => new Date(b[sortField] || 0).getTime() - new Date(a[sortField] || 0).getTime()
        );
      }, () => this.isLoading = false);
  }

  /**
   * Money refill: status=2 (payment_transactions) → success, иначе unknown.
   * Skin refill (method='market'): по fast_offer_status (state) — 10 → success,
   * 1..9 → waiting, null/>10 → error.
   */
  public getRefillStatusText(item: any): 'success' | 'waiting' | 'error' | 'unknown' {
    if (item?.method === 'market') {
      const state = item.state;
      if (state === 10) return 'success';
      if (state == null || state > 10) return 'error';
      return 'waiting';
    }
    return item?.status === 2 ? 'success' : 'unknown';
  }

  ngAfterViewInit() {
    this.userRefills.paginator = this.paginator;
    this.userRefills.sort = this.sort;
  }
  openUserData(transaction: {userData: string}): void {
    const params = {
      width: '500px',
      height: 'fit-content',
      data: transaction
    }
    this.dialog.open(UserTransactionComponent, params)

  }

  public getItemNames(name: string | undefined | null): string[] {
    if (!name) return [];
    return name.split(/\s*,\s*/).filter(Boolean);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.userRefills.filter = filterValue.trim().toLowerCase();

    if (this.userRefills.paginator) {
      this.userRefills.paginator.firstPage();
    }
  }
}
